import { jsx as _jsx, Fragment as _Fragment } from "react/jsx-runtime";
import { WEIGHT_DELTA_CHANGE_MAX, WEIGHT_DELTA_CHANGE_MIN } from '../lib/constant';
import { FiberManualRecord, ArrowDownward, ArrowUpward } from '@shared-app/ui/icons';
import styles from './styles.module.scss';
export function WeightIcon({ delta }) {
    return (_jsx(_Fragment, { children: delta > WEIGHT_DELTA_CHANGE_MIN && delta < WEIGHT_DELTA_CHANGE_MAX ? (_jsx(FiberManualRecord, { className: styles.circleIcon })) : delta <= WEIGHT_DELTA_CHANGE_MIN ? (_jsx(ArrowDownward, { className: styles.icon })) : (_jsx(ArrowUpward, { className: styles.icon })) }));
}
